/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import format from 'date-fns/format';
import {
  Button,
  Grid,
  Row,
  Col,
  Panel,
  Table,
  HelpBlock,
} from 'react-bootstrap';
import adrActions from 'loraactions/adr';
import PageLoading from 'loracoms/PageLoading';
import PageError from 'loracoms/PageError';
import ShowIf from 'loracoms/ShowIf';
import Toolbar from 'loracoms/Toolbar';
import RichLabel from 'loracoms/RichLabel';
import Nvl from 'loracoms/Nvl';
import TablePager from 'loracoms/TablePager';
import SelectPills from 'loracoms/SelectPills';
import ControlTips from 'loracoms/ControlTips';
import Select from 'loracoms/Select';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import ErrorSet from 'lorautils/errors/ErrorSet';
import {
  allSuccess,
  someFailure,
  findFailure,
} from 'lorautils/api/status';
import callAPI from 'loraapi/callAPI';
import DynamicChart from './DynamicChart';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  getNodeAdr: React.PropTypes.func.isRequired,
  getNodeAdrLogs: React.PropTypes.func.isRequired,
  nodeAdr: React.PropTypes.object.isRequired,
  nodeAdrLogs: React.PropTypes.object.isRequired,
  deviceState: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
  appState: React.PropTypes.object.isRequired,
  replaceState: React.PropTypes.func.isRequired,
};

const formatters = vl => (
  <span>
    {vl}
    <span className={styles.infos}>
      <span className={styles.info}>
        <i className="fa fa-angle-left" />
        MaxEIRP{vl > 0 ? `${vl * -2}dB` : ''}
        <i className="fa fa-angle-right" />
      </span>
    </span>
  </span>
);

const kAU915 = 'AU915';
const kDrOptions = _.map(_.range(6), i => ({ label: i, value: i }));
const kAU915Dr = _.map(_.range(7), i => ({ label: i, value: i }));
const kMarginOptions = _.map(_.range(1, 21), i => ({ label: i, value: i }));
const kPowerOptions = _.map(_.range(8), i => ({
  label: i,
  value: i,
  formatter: () => formatters(i),
}));
const kAU915Power = _.map(_.range(11), i => ({
  label: i,
  value: i,
  formatter: () => formatters(i),
}));

class ADRView extends React.Component {
  constructor(props) {
    super(props);
    const { nodeAdr } = props;
    this.state = {
      nodeAdr,
      nodeAdrLogs: props.nodeAdrLogs,
      deviceState: props.deviceState,
      appState: props.appState,
      errors: ErrorSet.createEmpty(),
      mindr: nodeAdr.data ? nodeAdr.data.mindr : undefined,
      maxdr: nodeAdr.data ? nodeAdr.data.maxdr : undefined,
      editMax: false,
      editMin: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.adrview');
    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleCancelEditMax = this.handleCancelEditMax.bind(this);
    this.handleCancelEditMin = this.handleCancelEditMin.bind(this);
    this.handleChangeMaxDR = this.handleChangeMaxDR.bind(this);
    this.handleChangeMinDR = this.handleChangeMinDR.bind(this);
    this.handleSubmitValue = this.handleSubmitValue.bind(this);
  }

  componentWillMount() {
    const { deviceId, getNodeAdr, getNodeAdrLogs } = this.props;
    getNodeAdr(deviceId);
    getNodeAdrLogs(deviceId);
  }

  componentWillReceiveProps(nextProps) {
    const { nodeAdr, nodeAdrLogs, deviceState, appState } = nextProps;
    if (nodeAdr !== this.props.nodeAdr) {
      this.setState({ nodeAdr });
      if (nodeAdr.data) {
        const { mindr, maxdr } = nodeAdr.data;
        this.setState({ mindr, maxdr });
      }
    }
    if (nodeAdrLogs !== this.props.nodeAdrLogs) {
      this.setState({ nodeAdrLogs });
      if (nodeAdrLogs.status === 'success') {
        this.setState({
          list: nodeAdrLogs.data.list,
          mark: nodeAdrLogs.data.mark,
          more: nodeAdrLogs.data.more,
        });
      }
    }
    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  handlePrev(mark) {
    const { deviceId, getNodeAdrLogs } = this.props;
    getNodeAdrLogs(deviceId, { mark });
  }

  handleNext(mark) {
    const { deviceId, getNodeAdrLogs } = this.props;
    getNodeAdrLogs(deviceId, { mark });
  }

  handleToggleAdr(selected) {
    const disabled = selected !== 'on';
    const { deviceId } = this.props;
    callAPI({ endpoint: `/lora/nodes/${deviceId}/adr`, method: 'PUT', query: {}, body: { disabled } })
      .then(() => {})
      .catch(() => {});
  }

  handleCancelEditMax() {
    const { errors } = this.state;
    this.setState({
      editMax: false,
      errors: errors.remove('maxdr'),
    });
  }

  handleCancelEditMin() {
    const { errors } = this.state;
    this.setState({
      editMin: false,
      errors: errors.remove('mindr'),
    });
  }

  handleChangeMaxDR(maxdr) {
    const { mindr, errors } = this.state;
    this.setState({ maxdr });

    if (!_.isNil(mindr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr'),
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr'),
        });
      }
    } else {
      this.setState({
        errors: errors.remove('maxdr'),
      });
    }
  }

  handleChangeMinDR(mindr) {
    const { maxdr, errors } = this.state;
    this.setState({ mindr });

    if (!_.isNil(maxdr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr'),
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr'),
        });
      }
    } else {
      this.setState({
        errors: errors.remove('mindr'),
      });
    }
  }

  handleSubmitValue(key, callback) {
    const { errors, nodeAdr } = this.state;
    const { deviceId } = this.props;
    const value = this.state[key];
    if (_.isNil(value) || errors.has(key)) {
      return;
    }

    callAPI({
      endpoint: `/lora/nodes/${deviceId}/adr`,
      method: 'PUT',
      body: { [key]: value },
    }).then(() => {
      if (callback) { callback(); }
      this.setState({
        nodeAdr: { ...nodeAdr, data: { ...nodeAdr.data, [key]: value } },
      });
    }).catch((err) => {
      this.setState({ errors: errors.add(err.code, key) });
    });
  }

  handleSubmitReset() {
    this.setState({ resetStatus: 'pending' });
    const { deviceId } = this.props;
    callAPI({
      endpoint: `/lora/nodes/${deviceId}/adr/reset`,
      method: 'POST',
    }).then(() => {
      this.setState({ resetStatus: 'success' });
    }).catch(() => {
      this.setState({ resetStatus: 'failure' });
    });
  }

  renderAdr() {
    const {
      nodeAdr: { data: nodeAdr },
      errors,
      editMax,
      editMin,
      editMargin = false,
      editPower = false,
      deviceState: { data: { band } = {} },
    } = this.state;
    const drOpts = band === kAU915 ? kAU915Dr : kDrOptions;
    const powerOpts = band === kAU915 ? kAU915Power : kPowerOptions;
    const options = [
      { name: this.intlMsg.msg('switch.on'), value: 'on', active: !nodeAdr.disabled },
      { name: this.intlMsg.msg('switch.off'), value: 'off', active: nodeAdr.disabled },
    ];
    return (
      <Panel bsStyle="aisz-white">
        <Row>
          <Col md={6}>
            <div>
              <div className={styles.title}>
                {this.intlMsg.msg('adrstatus.confirmed.title')}
              </div>
              <SelectPills
                options={options}
                onChange={selected => this.handleToggleAdr(selected[0])}
              />
            </div>
            <div className={styles.adapt}>
              <div className={styles.label}>
                Min DR:
              </div>
              <ShowIf if={editMin}>
                <div className={styles.selectArea}>
                  <div>
                    <Select
                      value={nodeAdr.mindr}
                      options={drOpts}
                      onChange={this.handleChangeMinDR}
                    />
                    <ControlTips
                      show={errors.has('mindr')}
                      message={this.intlMsg.errorMsg(errors.get('mindr'))}
                      azStyle="danger"
                      placement="top"
                    />
                  </div>
                  <div className={styles.actions}>
                    <Link
                      onClick={() => this.handleSubmitValue('mindr', () => {
                        this.setState({ editMin: false });
                      })}
                      className={styles.ok}
                    >
                      <span className="halflings halflings-ok" />
                    </Link>
                    <Link onClick={this.handleCancelEditMin} className={styles.cancel}>
                      <span className="halflings halflings-remove" />
                    </Link>
                  </div>
                </div>
              </ShowIf>
              <ShowIf if={!editMin}>
                <span>{nodeAdr.mindr}</span>
              </ShowIf>
              <ShowIf if={!editMin}>
                <Link onClick={() => this.setState({ editMin: true })} className={styles.edit}>
                  <span className={`halflings halflings-pencil ${styles.gray}`} />
                </Link>
              </ShowIf>
            </div>
            <div className={styles.adapt}>
              <div className={styles.label}>
                Max DR:
              </div>
              <ShowIf if={editMax}>
                <div className={styles.selectArea}>
                  <div>
                    <Select
                      value={nodeAdr.maxdr}
                      options={drOpts}
                      onChange={this.handleChangeMaxDR}
                    />
                    <ControlTips
                      show={errors.has('maxdr')}
                      message={this.intlMsg.errorMsg(errors.get('maxdr'))}
                      azStyle="danger"
                      placement="top"
                    />
                  </div>
                  <div className={styles.actions}>
                    <Link
                      onClick={() => this.handleSubmitValue('maxdr', () => {
                        this.setState({ editMax: false });
                      })}
                      className={styles.ok}
                    >
                      <span className="halflings halflings-ok" />
                    </Link>
                    <Link onClick={this.handleCancelEditMax} className={styles.cancel}>
                      <span className="halflings halflings-remove" />
                    </Link>
                  </div>
                </div>
              </ShowIf>
              <ShowIf if={!editMax}>
                <span>{nodeAdr.maxdr}</span>
              </ShowIf>
              <ShowIf if={!editMax}>
                <Link onClick={() => this.setState({ editMax: true })} className={styles.edit}>
                  <span className={`halflings halflings-pencil ${styles.gray}`} />
                </Link>
              </ShowIf>
            </div>
            <div className={styles.adapt}>
              <div className={styles.label}>
                Min Power:
              </div>
              <ShowIf if={editPower}>
                <div className={styles.selectArea}>
                  <div>
                    <Select
                      value={nodeAdr.minpower}
                      options={powerOpts}
                      onChange={minpower => this.setState({
                        minpower,
                        errors: errors.remove('minpower'),
                      })}
                    />
                    <ControlTips
                      show={errors.has('minpower')}
                      message={this.intlMsg.errorMsg(errors.get('minpower'))}
                      azStyle="danger"
                      placement="top"
                    />
                  </div>
                  <div className={styles.actions}>
                    <Link
                      onClick={() => this.handleSubmitValue('minpower', () => {
                        this.setState({ editPower: false });
                      })}
                      className={styles.ok}
                    >
                      <span className="halflings halflings-ok" />
                    </Link>
                    <Link
                      onClick={() => this.setState({ editPower: false })}
                      className={styles.cancel}
                    >
                      <span className="halflings halflings-remove" />
                    </Link>
                  </div>
                </div>
              </ShowIf>
              <ShowIf if={!editPower}>
                <span>{nodeAdr.minpower}</span>
              </ShowIf>
              <ShowIf if={!editPower}>
                <Link onClick={() => this.setState({ editPower: true })} className={styles.edit}>
                  <span className={`halflings halflings-pencil ${styles.gray}`} />
                </Link>
              </ShowIf>
            </div>
            <div className={styles.adapt}>
              <div className={styles.label}>
                Margin:
              </div>
              <ShowIf if={editMargin}>
                <div className={styles.selectArea}>
                  <div>
                    <Select
                      value={nodeAdr.margin}
                      options={kMarginOptions}
                      onChange={margin => this.setState({ margin })}
                    />
                    <ControlTips
                      show={errors.has('margin')}
                      message={this.intlMsg.errorMsg(errors.get('margin'))}
                      azStyle="danger"
                      placement="top"
                    />
                  </div>
                  <div className={styles.actions}>
                    <Link
                      onClick={() => this.handleSubmitValue('margin', () => {
                        this.setState({ editMargin: false });
                      })}
                      className={styles.ok}
                    >
                      <span className="halflings halflings-ok" />
                    </Link>
                    <Link
                      onClick={() => this.setState({ editMargin: false })}
                      className={styles.cancel}
                    >
                      <span className="halflings halflings-remove" />
                    </Link>
                  </div>
                </div>
              </ShowIf>
              <ShowIf if={!editMargin}>
                <span>{nodeAdr.margin || nodeAdr.default.margin}</span>
              </ShowIf>
              <ShowIf if={!editMargin}>
                <Link onClick={() => this.setState({ editMargin: true })} className={styles.edit}>
                  <span className={`halflings halflings-pencil ${styles.gray}`} />
                </Link>
              </ShowIf>
              <HelpBlock className="aisz-help-block">
                <i className="fa fa-info-circle" />&nbsp;
                {this.intlMsg.msg('margin.tips')}
              </HelpBlock>
            </div>
          </Col>
          <Col md={6}>
            <DynamicChart adr={nodeAdr} />
          </Col>
        </Row>
      </Panel>
    );
  }

  renderAdrLogs() {
    const {
      list = [],
      mark = '',
      more = false,
      nodeAdrLogs,
    } = this.state;

    const rows = list.map((item, idx) => (
      <tr key={`${item.appeui}-${item.deveui}-${item.$time}-${String(idx)}`}>
        <td>{format(new Date(item.$time), 'YYYY-MM-DD HH:mm:ss')}</td>
        <td>
          <RichLabel
            content={item.event}
            enums={[{
              content: 'manual',
              translate: this.intlMsg.msg('adr.event.manual'),
              theme: 'blue',
            }, {
              content: 'confirm',
              translate: this.intlMsg.msg('adr.event.confirm'),
              theme: 'green',
            }, {
              content: 'reject',
              translate: this.intlMsg.msg('adr.event.reject'),
              theme: 'red',
            }, {
              content: 'info',
              translate: this.intlMsg.msg('adr.event.info'),
              theme: 'blue',
            }, {
              content: 'warning',
              translate: this.intlMsg.msg('adr.event.warning'),
              theme: 'yellow',
            }, {
              content: 'error',
              translate: this.intlMsg.msg('adr.event.error'),
              theme: 'red',
            }, {
              content: 'auto',
              translate: this.intlMsg.msg('adr.event.auto'),
              theme: 'blue',
            }]}
          />
        </td>
        <td>{item.dr}</td>
        <td>{item.power}</td>
        <td><Nvl val={item.margin} /></td>
        <td><Nvl val={item.message} /></td>
      </tr>
    ));

    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('adrlogs.panelheader')}>
        <div className={styles.adrlogs}>
          <Table className="aisz-table-light" responsive>
            <thead>
              <tr>
                <th>{this.intlMsg.msg('adr.data.time')}</th>
                <th>{this.intlMsg.msg('adr.data.event')}</th>
                <th>{this.intlMsg.msg('adr.data.dr')}</th>
                <th>{this.intlMsg.msg('adr.data.power')}</th>
                <th>{this.intlMsg.msg('adr.data.margin')}</th>
                <th>{this.intlMsg.msg('adr.data.message')}</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
        </div>
        <div className={styles.pager}>
          <TablePager
            mark={mark}
            more={more}
            status={nodeAdrLogs.status}
            onPrev={this.handlePrev}
            onNext={this.handleNext}
          />
        </div>
      </Panel>
    );
  }

  renderContent() {
    const { resetStatus = '' } = this.state;
    const { pushState, appId, deviceId, replaceState } = this.props;
    const {
      deviceState: {
        data: { name } = {},
        status,
      },
      appState: {
        data: { name: appName } = {},
        status: appStatus,
      },
    } = this.state;
    const breadcrumb = [{
      content: this.intlMsg.msg('application.breadcrumb.application', ''),
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl val={appName} status={appStatus} />,
      onClick: () => replaceState(`/application/${appId}`),
    }, {
      content: <Nvl val={name || normalizeDevEUI(deviceId)} status={status} />,
      active: true,
    }];

    const rightTools = [{
      type: 'buttons',
      buttons: [(
        <Button
          bsStyle="aisz-danger"
          style={{ marginLeft: '30px' }}
          onClick={() => this.handleSubmitReset()}
        >
          {this.intlMsg.msg('switch.reset')}
          <ShowIf if={resetStatus === 'pending'}>
            <span className={`${styles.loading} ${styles.resetLoad}`}>
              <i className="fa fa-spinner fa-spin" />
            </span>
          </ShowIf>
          <ShowIf if={resetStatus === 'success'}>
            <i className={`${'fa fa-check'} ${styles.resetLoad}`} />
          </ShowIf>
          <ShowIf if={resetStatus === 'failure'}>
            <i className={`${'fa fa-exclamation'} ${styles.resetLoad}`} />
          </ShowIf>
        </Button>
      )],
    }];

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Toolbar breadcrumb={breadcrumb} rightTools={rightTools} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.renderAdr()}
            {this.renderAdrLogs()}
          </Col>
        </Row>
      </Grid>
    );
  }

  render() {
    const { nodeAdr, nodeAdrLogs, deviceState } = this.state;
    if (someFailure(nodeAdr, nodeAdrLogs, deviceState)) {
      const failOne = findFailure(nodeAdr, nodeAdrLogs, deviceState);
      return <PageError title={this.intlMsg.errorMsg(failOne.error.code)} />;
    }
    if (allSuccess(deviceState, nodeAdr)) {
      return this.renderContent();
    }
    return <PageLoading />;
  }
}

ADRView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  nodeAdr: state.adr.getNodeAdr || {},
  nodeAdrLogs: state.adr.getNodeAdrLogs || {},
  deviceState: state.device.getDevice || {},
  appState: state.app.getApp || {},
  appId: ownProps.params.appId,
  deviceId: ownProps.params.deviceId,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  replaceState: routerActions.replace,
  getNodeAdr: adrActions.getNodeAdr,
  getNodeAdrLogs: adrActions.getNodeAdrLogs,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ADRView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/ADRView/index.jsx